import { Injectable } from "@angular/core";

@Injectable()
export class HomeLobbyEffects { 
    //For future effects
}
